/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors } from '@blend/consumer-components';
import { BlIcon } from '@blend/shared-react';

import { mediaBreakpoints } from '../../../../../common/responsive';
import { ScreenReaderMessage } from '@components/ScreenReaderMessage/ScreenReaderMessage';

const styles = StyleSheet.create({
  completedTask: {
    display: 'inline-block',
    textAlign: 'center',
    color: colors.mint,
    width: 120,
    [mediaBreakpoints.mobile]: {
      width: 80,
    },
  },
  doneIconText: {
    marginRight: 10,
    [mediaBreakpoints.mobile]: {
      marginRight: 5,
    },
  },
});

export namespace ChoiceDoneIcon {
  export interface Props {
    value: string;
  }
}

export const ChoiceDoneIcon: React.FC<ChoiceDoneIcon.Props> = ({ value }) => (
  <div className={css(styles.completedTask)} data-it="it-completed-task">
    <span id={`it-complete-${value}`} className={css(styles.doneIconText)}>
      Done
    </span>
    <ScreenReaderMessage>Done</ScreenReaderMessage>
    <BlIcon icon="nav-complete" />
  </div>
);
